'use client';
import { useThemeContext } from 'shared/misc/providers/ThemeContext';
import { useInsertionEffect, useEffect, useRef } from 'react';

export function SetTheme() {
  const { activeTheme } = useThemeContext();
  const insertedClassesRef = useRef(false);

  useInsertionEffect(() => {
    try {
      if (!activeTheme) return;
      if (typeof window === 'undefined') return;
      if (typeof document === 'undefined') return;
      if (!document?.body) return;
      if (!document?.body?.classList) return;
      // Remove any existing theme classes
      document?.body?.classList?.forEach((className) => {
        if (className?.startsWith('theme-')) {
          document?.body?.classList?.remove(className);
        }
      });
      // Add new theme class
      document?.body?.classList?.add(`theme-${activeTheme.toLowerCase()}`);
      insertedClassesRef.current = true;
    } catch (error) {
      console.error(error);
    }
  }, [activeTheme]);

  return <></>;
}
